import React from "react";

const Modal = ({ isOpen, onClose, children, title = "" }) => {
  if (!isOpen) return null;

  const handleOverlayMouseDown = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div style={styles.overlay} onMouseDown={handleOverlayMouseDown}>
      <div style={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h3 style={styles.title}>{title}</h3>

          <button
            type="button"
            style={styles.closeButton}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={onClose}
            aria-label="Close modal"
          >
            X
          </button>
        </div>

        <div style={styles.content}>{children}</div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: 16,
    boxSizing: "border-box",
  },

  modal: {
    backgroundColor: "#fff",
    borderRadius: 8,
    width: "min(92vw, 700px)",
    height: "min(85vh, 900px)",
    overflow: "hidden",

    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e5e7eb",
    padding: "12px 14px",
    flexShrink: 0, // ✅ header never collapses
  },

  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
    color: "#111827",
  },

  closeButton: {
    border: "1px solid #e5e7eb",
    background: "#fff",
    borderRadius: 10,
    fontSize: 18,
    cursor: "pointer",
    color: "#111827",
    padding: "4px 10px",
    lineHeight: 1,
    flexShrink: 0,
  },

  content: {
    flex: 1,
    minHeight: 0,   // ✅ critical for scrolling children in flex
    overflow: "auto",
    padding: 14,
    boxSizing: "border-box",
  },
};

export default Modal;
